import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';

@Directive({
  selector: 'img[clAvatar]',
  standalone: true,
})
export class ChannelAvatarImageDirective implements OnInit, OnDestroy {
  constructor(private host: ElementRef<HTMLImageElement>) {}

  @Input() set clAvatar(url: string | null) {
    const img = this.host.nativeElement;
    const next = url?.trim() || '';
    if (img.dataset.avatarUrl === next) {
      this.revealIfReady();
      return;
    }
    img.dataset.avatarUrl = next;
    img.classList.remove('is-loaded');
    if (!next) {
      img.removeAttribute('src');
      return;
    }
    img.src = next;
    this.revealIfReady();
  }

  ngOnInit(): void {
    const img = this.host.nativeElement;
    img.addEventListener('load', this.onLoad);
    img.addEventListener('error', this.onError);
    this.revealIfReady();
  }

  ngOnDestroy(): void {
    const img = this.host.nativeElement;
    img.removeEventListener('load', this.onLoad);
    img.removeEventListener('error', this.onError);
  }

  private onLoad = (): void => this.revealIfReady();

  private onError = (): void => {
    this.host.nativeElement.classList.remove('is-loaded');
  };

  private revealIfReady(): void {
    const img = this.host.nativeElement;
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('is-loaded');
    }
  }
}
